module.exports = __webpack_public_path__ + "img/app-store.89129d76.png";